import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Image,
  Badge,
  Button,
  ListGroup,
  Spinner,
} from "react-bootstrap";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { bookedAds, expressedInterestUser } from "../../services/UserServices/UserService";
import Pagination from "../components/Pagination";
import { startCase } from "lodash";

const formatDate = (date) =>
  date
    ? new Date(date).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "N/A";

const InterestedUsersPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage ?? 0
  );
  const [interestedTotal, setInterestedTotal] = useState(0);
  const [interestedLoading, setInterestedLoading] = useState(false);
const today = new Date().toISOString().split("T")[0];
  const [dealUser, setDealUser] = useState([]);
  const [bookedPage, setBookedPage] = useState(
    location.state?.bookedPage ?? 0
  );

  useEffect(() => {
    if (currentPage !== undefined || bookedPage !== undefined) {
      navigate(".", {
        replace: true,
        state: { ...location.state, currentPage, bookedPage },
      });
    }
  }, [currentPage, bookedPage]);
  const [bookedTotal, setBookedTotal] = useState(0);
  const [bookedLoading, setBookedLoading] = useState(false);
 const [startDate,setStartDate]=useState()
 const [endDate,setEndDate]=useState()
   const isFilterActive =  startDate || endDate ;
  const LIMIT = 5;

  const fetchInterestedUsers = async () => {
    setInterestedLoading(true);
    try {
      const res = await expressedInterestUser(id, currentPage, LIMIT,startDate,endDate);
      const payload = res?.data?.data;
      setUsers(payload?.data || []);
      // use the real total count from the API, not the array's own length
      setInterestedTotal(payload?.total );
    } catch (error) {
      console.error("Error fetching interested users:", error);
    } finally {
      setInterestedLoading(false);
    }
  };

  const fetchBooking = async () => {
    setBookedLoading(true);
    try {
      const res = await bookedAds(id, bookedPage, LIMIT,startDate,endDate);
      const payload = res?.data?.data;
      setDealUser(payload?.data || []);

      setBookedTotal(payload?.total);
    } catch (error) {
      console.error("Error fetching booked ads:", error);
    } finally {
      setBookedLoading(false);
    }
  };
 const handleClear = () => {
    
    setStartDate("");
    setEndDate("");
     
  };
  useEffect(() => {
    if (id) fetchInterestedUsers();
  }, [id, currentPage,endDate]);

  useEffect(() => {
    if (id) fetchBooking();
  }, [id, bookedPage,startDate,endDate]);

  
  const totalPages = Math.ceil(interestedTotal / LIMIT);
  const bookedTotalPages = Math.ceil(bookedTotal / LIMIT);
  console.log("booke tossstal",bookedTotal)
console.log("booke total",bookedTotalPages)
  return (
    <Container className="mt-4 mb-5">
    
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
        <div>
          <Button
            variant="light"
            size="sm"
            className="mb-2 shadow-sm"
            onClick={() => navigate(-1)}
          >
            &larr; Back
          </Button>
        <h2 style={{ color: "#E5484D", fontWeight: "bold", margin: 0 }}>
    {dealUser?.[0]?.ad?.title && (
    <span
      onClick={() => navigate(`/listing-detail/${dealUser[0].ad._id}`)}
      style={{
        color: "#0d6efd",
        cursor: "pointer",
       
      }}
    >
      ({dealUser[0].ad.title})
    </span>
  )}
  Property Interest & Deal Status
</h2>
        </div>

        <div className="d-flex gap-2">
              <div>
          <label className="form-label mb-1" style={{ fontSize: "12px" }}>
            Start Date
          </label>
          <input
            type="date"
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
            className="form-control"
            value={startDate}
               max={today}  
    onChange={(e) => {
      setStartDate(e.target.value); 
      if (endDate && e.target.value > endDate) {
        setEndDate("");
      }
    }}
          />
        </div>

        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px" }}>
            End Date
          </label>
          <input
            type="date"
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
            className="form-control"
            value={endDate}
            min={startDate}
                disabled={!startDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
 {isFilterActive && (
          <div className="d-flex flex-column">
            <label className="form-label mb-1" style={{ fontSize: "12px" }}>
              &nbsp;
            </label>
            <button
              className="btn btn-outline-danger"
              onClick={handleClear}
              style={{ borderRadius: "0.5rem" }}
            >
              Clear
            </button>
          </div>
        )}

        </div>


      </div>

      {/* align-items-start prevents the two cards from being force-stretched to equal height */}
      <Row className="g-4 align-items-start">
        
        <Col md={7}>
          <Card className="shadow-sm border-0 rounded-4">
            <Card.Body className="p-4 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 style={{color:'#E5484D'}} className="fw-bold mb-0 ">
                    <i className="bi bi-people-fill me-2"></i>
                    Interested Users
                  </h5>
                  <Badge pill style={{ backgroundColor: "#E5484D" }} className="px-3 py-2">
                    {interestedTotal}
                  </Badge>
                </div>

                {interestedLoading ? (
                  <div className="text-center py-4">
                    <Spinner animation="border" variant="danger" />
                  </div>
                ) : users.length === 0 ? (
                  <p className="text-muted text-center py-4">
                    No users have shown interest yet.
                  </p>
                ) : (
                  <ListGroup variant="flush">
                    {users.map((user) => (
                   <ListGroup.Item
  key={user._id}
  className="d-flex align-items-center gap-3 py-3 px-0 border-bottom"
>
  <Image
    src={
      user.user?.image ||
      "https://www.pngfind.com/pngs/m/610-6104451_image-placeholder-png-user-profile-placeholder-image-png.png"
    }
    roundedCircle
    width={56}
    height={56}
    className="object-fit-cover border shadow-sm flex-shrink-0"
    alt={user.user?.name || "User"}
  />

  <div className="flex-grow-1 d-flex justify-content-between align-items-center">
    <h6
      className="fw-bold mb-0 cursor-pointer"
      style={{ color: "#0d6efd" }}
      onClick={() => navigate(`/user-detail/${user._id}`)}
    >
      {user.user?.name || "N/A"}
    </h6>

    <small className="text-muted">
      {formatDate(user.interestedOn || user.createdAt)}
    </small>
  </div>
</ListGroup.Item>
                    ))}
                  </ListGroup>
                )}
              </div>

              {totalPages > 1 && (
                <div className="mt-4">
                  <Pagination
                    pageCount={totalPages}
                    pageValue={currentPage}
                    setPage={setCurrentPage}
                  />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* ---------------- RIGHT: Deal Signed User ---------------- */}
        <Col md={5}>
          <Card className="shadow-sm border-0 rounded-4">
            <Card.Body className="p-4 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 style={{color:'#E5484D'}} className="fw-bold mb-0 ">
                    <i className="bi bi-people-fill me-2"></i>
                    Deal Signed With 
                  </h5>
                  <Badge pill style={{ backgroundColor: "#E5484D" }} className="px-3 py-2">
                    {bookedTotal}
                  </Badge>
                </div>

                {bookedLoading ? (
                  <div className="text-center py-4">
                    <Spinner animation="border" variant="success" />
                  </div>
                ) : !dealUser || dealUser.length === 0 ? (
                  <p className="text-muted text-center py-4">
                    No deal has been signed for this property yet.
                  </p>
                ) : (
                  dealUser.map((user, index) => {
                    const bookedBy = user.bookedBy || {};
                    return (
                      <div
                        className="text-center mb-4 p-3 rounded-xl"
                        key={user._id || index}
                        style={{
                          border: "1px solid #E5484D",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                        }}
                      >
                        <Image
                          src={
                            bookedBy.image ||
                            "https://www.pngfind.com/pngs/m/610-6104451_image-placeholder-png-user-profile-placeholder-image-png.png"
                          }
                          roundedCircle
                          width={100}
                          height={100}
                          className="object-fit-cover shadow-sm border mb-3"
                          alt={bookedBy.name || "User"}
                        />

                        <h5
                          style={{ color: "#0d6efd" }}
                          className="fw-bold mb-1 cursor-pointer"
                          onClick={() => navigate(`/user-detail/${bookedBy._id || bookedBy.id}`)}
                        >
                          {bookedBy.name || "N/A"}
                        </h5>

                        <ListGroup variant="flush" className="rounded-3 text-start">
                          {bookedBy.phone && (
                            <ListGroup.Item className="d-flex justify-content-between">
                              <span className="text-muted">Phone</span>
                              <span className="fw-medium">{bookedBy.phone}</span>
                            </ListGroup.Item>
                          )}

                          <ListGroup.Item className="d-flex justify-content-between">
                            <span className="text-muted">Deal Signed On</span>
                            <span className="fw-medium">{formatDate(user.createdAt)}</span>
                          </ListGroup.Item>
                        </ListGroup>
                      </div>
                    );
                  })
                )}
              </div>

              {bookedTotalPages > 1 && (
                <div className="mt-4">
                  <Pagination
                    pageCount={bookedTotalPages}
                    pageValue={bookedPage}
                    setPage={setBookedPage}
                  />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default InterestedUsersPage;